import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export default function PrivateRoute({
  children,
  allowedPerms = [],
}: {
  children: React.ReactNode;
  allowedPerms?: string[];
}) {
  const { user, perms, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="p-8">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  if (allowedPerms.length && !allowedPerms.every(p => (perms ?? []).includes(p))) {
    return <div className="p-8">Not authorized</div>;
  }
  return <>{children}</>;
}
